import React from 'react';

export default function PageHeader({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6 flex-wrap">
      <div>
        <h1 className="text-[22px] font-black text-gray-900 tracking-tight">{title}</h1>
        {subtitle && <p className="text-[13px] text-gray-500 font-medium mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
